import request from '@/http/request';

export function getStaffInfo(params) {
    return request({
      url: '/api/v1/ops/staff_info',
      method: 'get',
      params,
    });
  }

export function getDcopsList(data) {
  return request({
    url: '/api/v1/ops/get_dcops_staff',
    method: 'post',
    data: data,
  });
}

export function UpdateDcopsList(data) {
  return request({
    url: '/api/v1/ops/update_dcops_staff',
    method: 'post',
    data: data,
  });
}